import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
  makeStyles
} from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'
import LambdaFetch from '../functions/FetchFromLambda'
import PayRateHistory from '../components/PayRateHistory'
import Deductions from '../components/Deductions'
import EmployeeChecks from '../components/EmployeeChecks'
import Main from '../components/Main'
import PayrollHistory from '../components/PayrollHistory'
import FieldHistory from '../components/FieldHistory'
import LoadingButton from '../components/LoadingButton'
import UserFields from '../components/UserFields'
import PersonalActions from '../components/PersonalActions'
import EmployeeTax from '../components/EmployeeTax'
import {
  Card,
  CardContent,
  Button,
  TextField,
  Paper,
  IconButton
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Benefits from '../components/Benefits'
import Beneficiaries from '../components/Beneficiaries'
import Dependents from '../components/Dependents'
import { AntTabs } from '../components/VendorTabs'
import fetchFromAthena from '../functions/FetchFromAthena'
import PositionHistory from "./PositionHistory";
import OpenSearchDropdown from '../components/OpenSearchDropdown';
import { getSubpagesByModule } from '../config/permissions-registry';
import DocumentList from '../components/DocumentList'
import RecordExportButton from '../components/RecordExportButton'
import { employeeExportConfig } from '../config/exportConfigs'

const searchByOptions = [
  {
    label: 'SSN',
    id: 'FICA_NBR'
  },
  {
    label: 'Email',
    id: 'EMAIL_ADDRESS'
  }
]

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  padding: {
    padding: theme.spacing(1)
  },
  demo1: {
    backgroundColor: theme.palette.background.paper
  },
  demo2: {
    backgroundColor: '#3F51B6'
  }
}))

export default function CustomizedTabs(props) {
  const { credentials } = props.fetchInitialData
  const classes = useStyles()
  const [state, setState] = useState({
    employee: null,
    history: [],
    actions: [],
    deductions: [],
    checks: [],
    fields: [],
    userFields: [],
    years: [],
    benefits: [],
    dependents: [],
    dependentBenefits: [],
    reviews: [],
    certificates: [],
    disciplinaryActions: [],
    taxHeader: {},
    taxDetail: [],
    companies: [],
    positionHistory: [],
    fetched: false
  })
  const [showTable, setShowTable] = useState(false)
  const [employeeKey, setEmployeeKey] = React.useState(false)
  const [loadingType, setLoadingType] = React.useState(null)
  const [isLoading, setLoading] = React.useState(false)
  const [empId, setEmpId] = React.useState(null)
  const [company, setCompany] = React.useState('')
  const [value, setValue] = React.useState(0)
  const [inputVal, setInputVal] = React.useState('')
  const [advSearchOpen, setAdvSearchOpen] = React.useState(false)
  const [searchByVal, setSearchByVal] = React.useState(null)
  const [isSearching, setSearching] = React.useState(false)
  const [clearHeader, setClearHeader] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)
  const [loadedTabs, setLoadedTabs] = React.useState(new Set())
  const [loadingTabs, setLoadingTabs] = React.useState(new Set())
  const [companyInitialValue, setCompanyInitialValue] = React.useState(null)
  const [employeeInitialValue, setEmployeeInitialValue] = React.useState(null)

  // Use centralized allow from credentials (with wildcard support)
  const allow = props?.fetchInitialData?.credentials?.allow || (() => false)
  // Convenience for HR subpage checks - memoized to prevent recreating loadTabData
  const allowHr = useCallback((subkey) => allow('subpage', 'HR', subkey), [allow])

  const getNextEmployee = async (id, type) => {
    setLoadingType(type)
    setEmployeeKey(!employeeKey)
    const next = await getEmployee(id)
    setInputVal(`${next.first} ${next.last} (${next.id})`)
    setLoadingType(null)
    // Tab will be reset to 0 in getEmployee function
  }

  const handleSubmit = async (employee) => {
    if (!employee || !company) {
      props.createSnack('Company and Employee are required', 'warning', 3000)
      return
    }
    setLoading(true)
    await getEmployee(employee)
    setLoading(false)
  }
  // const checkSecurity = async (props) => {
  //   const { company, employee } = props
  //   try {
  //     const resp = await LambdaFetch(
  //       'employee-form',
  //       'post',
  //       credentials.user.accessToken,
  //       JSON.stringify({
  //         action: 'check-security',
  //         company,
  //         employee
  //       }),
  //       '',
  //       credentials
  //     )
  //     const access = resp?.data?.response?.access_granted
  //     return access
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  const getEmployee = async (employee, companyOverride) => {
    // const access = await checkSecurity({ company, employee })

    // console.log('access', access)
    // if (access === 400) {
    //   props.createSnack('You are not allowed to view this employee', 'warning', 3000)
    //   return
    // }
    // Only fetch main employee data initially
    // Note: allowHr('main') now automatically checks registry via the allow function
    const companyToUse = companyOverride || company
    const query = `employee_main_read${allowHr('main') ? '' : 'false'}`

    const result = await fetchFromAthena({
      queryName: query,
      headers: {
        company: companyToUse,
        empId: employee ? employee : empId
      },
      accessToken: credentials.user.accessToken,
      credentials: credentials
    })

    if(!result?.[0]) {
      props.createSnack('Record not found or secured', 'warning', 3000)
      return
    }

    setState({
      ...state,
      employee: result[0] || {},
      history: [],
      actions: [],
      deductions: [],
      years: [],
      checks: [],
      fields: [],
      userFields: [],
      benefits: [],
      dependents: [],
      dependentBenefits: [],
      reviews: [],
      certificates: [],
      disciplinaryActions: [],
      taxHeader: {},
      taxDetail: [],
      positionHistory: [],
    })
    setShowTable(true)
    // Reset to first tab when new employee data is loaded
    setValue(0)
    // Reset loaded tabs when new employee is selected
    setLoadedTabs(new Set([0])) // Main tab is always loaded
    // Clear any loading states
    setLoadingTabs(new Set())
  }

  const employeeRef = useRef(null)
  const loadedTabsRef = useRef(new Set())
  const loadingTabsRef = useRef(new Set())
  
  // Keep refs in sync with state
  useEffect(() => {
    employeeRef.current = state.employee
  }, [state.employee])

  useEffect(() => {
    loadedTabsRef.current = loadedTabs
  }, [loadedTabs])

  useEffect(() => {
    loadingTabsRef.current = loadingTabs
  }, [loadingTabs])

  const loadTabData = useCallback(async (tabValue) => {
    const currentEmployee = employeeRef.current
    if (!currentEmployee) {
      return
    }

    // Prevent duplicate calls
    if (loadedTabsRef.current.has(tabValue) || loadingTabsRef.current.has(tabValue)) {
      return
    }

    // Mark tab as loading
    setLoadingTabs(prev => new Set([...prev, tabValue]))

    const tabQueries = []

    // Map tab values to their queries
    // Note: allowHr() now automatically checks registry via the allow function
    if (tabValue === 1 && allowHr('pay-rate-history')) {
      tabQueries.push({ query: `pay_rate_hist_read${allowHr('pay-rate-history') ? '' : 'false'}`, key: 'history' })
    }
    if (tabValue === 2 && allowHr('personnel-action')) {
      tabQueries.push(
        { query: `pers_act_read${allowHr('personnel-action') ? '' : 'false'}`, key: 'actions' },
        { query: `employee_reviews_read${allowHr('reviews') ? '' : 'false'}`, key: 'reviews' },
        { query: `employee_certifications_read${allowHr('certifications') ? '' : 'false'}`, key: 'certificates' },
        { query: `employee_disciplinary_actions${allowHr('disciplinary') ? '' : 'false'}`, key: 'disciplinaryActions' }
      )
    }
    if (tabValue === 3 && allowHr('tax')) {
      tabQueries.push(
        { query: `employee_tax_header_read${allowHr('tax') ? '' : 'false'}`, key: 'taxHeader' },
        { query: `employee_tax_detail_read${allowHr('tax') ? '' : 'false'}`, key: 'taxDetail' }
      )
    }
    if (tabValue === 4 && allowHr('deductions')) {
      tabQueries.push({ query: `emp_deduction_read${allowHr('deductions') ? '' : 'false'}`, key: 'deductions' })
    }
    if (tabValue === 5 && allowHr('payroll-history')) {
      tabQueries.push({ query: `emp_payroll_year_read${allowHr('payroll-history') ? '' : 'false'}`, key: 'years' })
    }
    if (tabValue === 6 && allowHr('pay-stubs')) {
      tabQueries.push({ query: `employee_checks_read${allowHr('pay-stubs') ? '' : 'false'}`, key: 'checks' })
    }
    if (tabValue === 7 && allowHr('field-history')) {
      tabQueries.push({ query: `padict_fields_read${allowHr('field-history') ? '' : 'false'}`, key: 'fields' })
    }
    if (tabValue === 8 && allowHr('user-fields')) {
      tabQueries.push({ query: `user_field_read${allowHr('user-fields') ? '' : 'false'}`, key: 'userFields' })
    }
    if (tabValue === 9 && allowHr('benefits')) {
      tabQueries.push({ query: `benefits_read${allowHr('benefits') ? '' : 'false'}`, key: 'benefits' })
    }
    if (tabValue === 11 && allowHr('dependents')) {
      tabQueries.push(
        { query: `dependent_read${allowHr('dependents') ? '' : 'false'}`, key: 'dependents' },
        { query: `dependent_benefit_read${allowHr('dependents') ? '' : 'false'}`, key: 'dependentBenefits' }
      )
    }
    if (tabValue === 12 && allowHr('position-history')) {
      tabQueries.push({ query: `employee_position_history${allowHr('position-history') ? '' : 'false'}`, key: 'positionHistory' })
    }

    if (tabQueries.length === 0) {
      // Tab doesn't need data fetching (e.g., beneficiaries uses empId/company directly)
      setLoadedTabs(prev => new Set([...prev, tabValue]))
      setLoadingTabs(prev => {
        const next = new Set(prev)
        next.delete(tabValue)
        return next
      })
      return
    }

    const data = await Promise.allSettled(
      tabQueries.map(({ query }) =>
        fetchFromAthena({
          queryName: query,
          headers: {
            company,
            empId: currentEmployee.EMPLOYEE
          },
          accessToken: credentials.user.accessToken,
          credentials: credentials
        })
      )
    )

    const updates = {}
    tabQueries.forEach(({ key }, index) => {
      const result = data[index]?.value || []
      if (key === 'taxHeader') {
        updates[key] = result[0] || {}
      } else {
        updates[key] = result
      }
    })

    setState(prevState => ({
      ...prevState,
      ...updates
    }))
    setLoadedTabs(prev => new Set([...prev, tabValue]))
    setLoadingTabs(prev => {
      const next = new Set(prev)
      next.delete(tabValue)
      return next
    })
  }, [company, credentials, allowHr])

  const fetchAllForExport = useCallback(async () => {
    const currentEmployee = employeeRef.current
    if (!currentEmployee) return null

    // Build all queries for every permitted tab, regardless of what's already loaded
    const allQueries = []

    if (allowHr('pay-rate-history')) {
      allQueries.push({ query: 'pay_rate_hist_read', key: 'history' })
    }
    if (allowHr('personnel-action')) {
      allQueries.push(
        { query: 'pers_act_read', key: 'actions' },
        { query: 'employee_reviews_read', key: 'reviews' },
        { query: 'employee_certifications_read', key: 'certificates' },
        { query: 'employee_disciplinary_actions', key: 'disciplinaryActions' }
      )
    }
    if (allowHr('tax')) {
      allQueries.push(
        { query: 'employee_tax_header_read', key: 'taxHeader' },
        { query: 'employee_tax_detail_read', key: 'taxDetail' }
      )
    }
    if (allowHr('deductions')) {
      allQueries.push({ query: 'emp_deduction_read', key: 'deductions' })
    }
    if (allowHr('payroll-history')) {
      allQueries.push({ query: 'emp_payroll_year_read', key: 'years' })
    }
    if (allowHr('pay-stubs')) {
      allQueries.push({ query: 'employee_checks_read', key: 'checks' })
    }
    if (allowHr('field-history')) {
      allQueries.push({ query: 'padict_fields_read', key: 'fields' })
    }
    if (allowHr('user-fields')) {
      allQueries.push({ query: 'user_field_read', key: 'userFields' })
    }
    if (allowHr('benefits')) {
      allQueries.push({ query: 'benefits_read', key: 'benefits' })
    }
    if (allowHr('dependents')) {
      allQueries.push(
        { query: 'dependent_read', key: 'dependents' },
        { query: 'dependent_benefit_read', key: 'dependentBenefits' }
      )
    }
    if (allowHr('position-history')) {
      allQueries.push({ query: 'employee_position_history', key: 'positionHistory' })
    }

    // Fire all API calls in parallel
    const results = await Promise.allSettled(
      allQueries.map(({ query }) =>
        fetchFromAthena({
          queryName: query,
          headers: { company, empId: currentEmployee.EMPLOYEE },
          accessToken: credentials.user.accessToken,
          credentials
        })
      )
    )

    // Build the complete export data object directly from API responses
    const exportData = { employee: currentEmployee }
    allQueries.forEach(({ key }, index) => {
      const value = results[index]?.value || []
      if (key === 'taxHeader') {
        exportData[key] = value[0] || {}
      } else {
        exportData[key] = value
      }
    })

    return exportData
  }, [company, credentials, allowHr])

  useEffect(() => {
    if (showTable && employeeRef.current && !loadedTabsRef.current.has(value) && !loadingTabsRef.current.has(value)) {
      loadTabData(value)
    }
  }, [value, showTable, loadTabData])

  // Handle URL query parameters for deep linking from Employee Advanced Search
  const urlParamsProcessed = useRef(false)
  useEffect(() => {
    if (urlParamsProcessed.current) return
    const searchParams = new URLSearchParams(props.location.search)
    const urlCompany = searchParams.get('company')
    const urlEmployee = searchParams.get('employee')

    if (urlCompany && urlEmployee) {
      urlParamsProcessed.current = true
      setCompany(urlCompany)
      setEmpId(urlEmployee)
      setCompanyInitialValue({ DISPLAY: urlCompany, VALUE: urlCompany })
      setEmployeeInitialValue({ DISPLAY: urlEmployee, VALUE: urlEmployee })
      // Auto-fetch employee data
      setLoading(true)
      getEmployee(urlEmployee, urlCompany).then(() => {
        setLoading(false)
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const advSearch = async event => {
  //   event.preventDefault()
  //   const searchBy = searchByVal
  //   const searchVal = event.target.searchValue.value
  //   if (!(searchBy && searchVal)) {
  //     return null
  //   }
  //   setSearching(true)
  //   const resp = await LambdaFetch(
  //     'employee-search',
  //     'post',
  //     credentials.user.accessToken,
  //     JSON.stringify(
  //       {
  //         lookupType: searchBy,
  //         lookupVal: searchVal,
  //         company: company
  //       }),
  //     '',
  //     credentials
  //   )
  //   const emp = resp.data.emp
  //   if (!emp || !emp.EMPLOYEE) {
  //     props.createSnack('No employee found', 'warning', 3000)
  //   } else {
  //     await handleSubmit(emp.EMPLOYEE)
  //     setAdvSearchOpen(false)
  //     setClearHeader(!clearHeader)
  //     setCompany('')
  //     setEmpId(null)
  //     setInputVal('')
  //     // Tab will be reset to 0 in getEmployee function
  //   }
  //   setSearching(false)
  // }
  const advHelperText =
    searchByVal === 'FICA_NBR' ? 'Must be in form XXX-XX-XXXX' : ''

  const {
    employee,
    history,
    actions,
    deductions,
    years,
    checks,
    fields,
    userFields,
    benefits,
    dependents,
    dependentBenefits,
    reviews,
    certificates,
    disciplinaryActions,
    taxHeader,
    taxDetail,
    positionHistory
  } = state

  const constructHrTabs = () => {
    const permissions = {}
    const hrTabs = []
    
    // Get all HR subpages from the permissions registry
    const hrSubpages = getSubpagesByModule('HR')
    
    // Only show tabs that user has permission for
    // Note: allowHr() now automatically checks registry via the allow function
    // Filter out sub-subpages (they have a 'parent' property and are handled within their parent tab)
    hrSubpages.forEach(subpage => {
      // Skip sub-subpages (they have a parent property)
      if (subpage.parent) {
        // Still add permission check for sub-subpages, but don't render as tab
        if (allowHr(subpage.key)) {
          permissions[subpage.key] = true
        }
        return
      }
      
      // Check if user has permission for this subpage
      // The allow function will automatically check the registry first
      if (allowHr(subpage.key)) {
        hrTabs.push({
          display: subpage.displayName,
          value: subpage.tabValue
        })
        permissions[subpage.key] = true
      }
    })
    
    return {hrTabs,permissions}
  }
  const {hrTabs,permissions} = constructHrTabs()
  return (
    <div className={classes.root}>
      <Paper
        elevation={0}
        style={{ marginTop: '2rem', width: '100%', padding: '1rem' }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} style={{ position: 'relative' }}>
            <div style={{ margin: '0 1rem 0 0' }}>
              <Grid
                container
                alignContent='center'
                alignItems='flex-start'
                spacing={3}
              >
                <Grid item>
                  <OpenSearchDropdown
                      id='company'
                      required
                      width='250px'
                      label='Company'
                      page="EMPLOYEE"
                      entity="COMPANY"
                      searchFields={['DISPLAY']}
                      accessToken={credentials.user.accessToken}
                      credentials={credentials}
                      clearTrigger={clearTrigger}
                      initialValue={companyInitialValue}
                      onChange={(val) => {setCompany(val?.VALUE || null)}}
                  />
                </Grid>
                <Grid item>
                  <OpenSearchDropdown
                      id='employee'
                      required
                      disabled={!company}
                      width='300px'
                      label='Employee'
                      page="EMPLOYEE"
                      entity="EMPLOYEE"
                      searchFields={['DISPLAY']}
                      accessToken={credentials.user.accessToken}
                      credentials={credentials}
                      clearTrigger={clearTrigger}
                      initialValue={employeeInitialValue}
                      filters={{
                        COMPANY: company
                      }}
                      onChange={(val) => {setEmpId(val?.VALUE || null)}}
                  />
                </Grid>
              </Grid>
            </div>

{/* 
            <div
              style={{
                display: advSearchOpen ? 'inline-block' : 'none',
                position: 'absolute',
                zIndex: 999
              }}
            >
              <Paper elevation={2} style={{ padding: '1rem' }}>
                <Typography variant='h6'>Advanced Search</Typography>
                <IconButton
                  style={{ position: 'absolute', right: 0, top: 0 }}
                  onClick={() => setAdvSearchOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
                <form onSubmit={advSearch}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        id='searchBy'
                        options={searchByOptions}
                        onChange={(event, value) => {
                          value === null
                            ? setSearchByVal(null)
                            : setSearchByVal(value.id)
                        }}
                        getOptionLabel={option => option.label}
                        renderInput={params => (
                          <TextField
                            {...params}
                            margin='dense'
                            label='Search By'
                            variant='outlined'
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id='searchValue'
                        label='Value'
                        fullWidth
                        variant='outlined'
                        margin='dense'
                        helperText={advHelperText}
                        autoComplete='off'
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <LoadingButton
                        label='Search'
                        isLoading={isSearching}
                        color='primaryVLButton'
                        buttonType='submit'
                      />
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </div>
*/}
          </Grid>
          <div style={{ marginTop: '1rem' }}>
            <LoadingButton
              disabled={!company || !empId}
              label='Submit'
              isLoading={isLoading}
              color='primaryVLButton'
              fn={() => handleSubmit(empId)}
            />
            {!!(company || empId) && (
              <Button
                onClick={() => {
                  setClearHeader(!clearHeader)
                  setCompany('')
                  setEmpId(null)
                  setInputVal('')
                  setClearTrigger(prev => !prev)
                }}
                style={{ marginLeft: '0.5rem' }}
              >
                Clear
              </Button>
            )}
          </div>
        </Grid>
      </Paper> 

      {showTable && (
        <Card style={{ margin: '1rem auto' }}>
          <CardContent style={{ position: 'relative' }}>
            <div>
              {/* {!!loadingType ? (
                <LoadingCircle />
              ) : ( */}
              <>
                <div
                  style={{
                    display: 'flex',
                    marginTop: '0.5rem',
                    justifyContent: 'flex-start'
                  }}
                >
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant='h5'>{`${employee.FIRST_NAME} ${employee.MIDDLE_INIT ? `${employee.MIDDLE_INIT}.` : ''
                        } ${employee.LAST_NAME}`}</Typography>
                      <RecordExportButton
                        recordData={state}
                        sections={employeeExportConfig}
                        fileName={`Employee_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                        onFetchAll={fetchAllForExport}
                        loadedSections={loadedTabs}
                        createSnack={props.createSnack}
                      />
                    </div>
                    <Typography variant='subtitle1'>{`Employee ID: ${employee.EMPLOYEE}`}</Typography>
                    <DocumentList
                      path={`employees/${employee.COMPANY}/${employee.EMPLOYEE}`}
                      credentials={credentials}
                      linkText="View Documents"
                      title="Employee Documents"
                      baseFolderLabel="Documents"
                      key={`${employee.COMPANY}_${employee.EMPLOYEE}`}
                  />
                  </div>
                </div>
                <div className={classes.demo1}>
                  <AntTabs
                    value={value}
                    color={credentials.primaryAppColor}
                    handleChange={(event, newValue) => {
                      setValue(newValue)
                    }}
                    controlledTabs
                    tabs={hrTabs}
                  />

                  <Typography className={classes.padding} />
                  {value === 0 && permissions['main'] && <Main data={employee} />}
                  {value === 1 && permissions['pay-rate-history'] &&  (
                    <PayRateHistory
                      {...props}
                      fileName={`Pay_Rate_History_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      employee={employee.EMPLOYEE}
                      company={company}
                      data={history}
                      isLoading={loadingTabs.has(1)}
                    />
                  )}
                  {value === 2 && permissions['personnel-action'] && (
                    <PersonalActions
                      data={{ actions, reviews, certificates, disciplinaryActions }}
                      empId={employee.EMPLOYEE}
                      employee={employee}
                      fileName={`Personnel_Action_History_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      company={company}
                      accessToken={credentials.user.accessToken}
                      isLoading={loadingTabs.has(2)}
                      {...props}
                    />
                  )}
                  {value === 3 && permissions['tax'] && (
                    <EmployeeTax
                      {...props}
                      data={{
                        taxHeader,
                        taxDetail
                      }}
                      fileName={`Tax_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      isLoading={loadingTabs.has(3)}
                    />
                  )}
                  {value === 4 && permissions['deductions'] && (
                    <Deductions
                      data={deductions}
                      fileName={`Deductions_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      isLoading={loadingTabs.has(4)}
                    />
                  )}
                  {value === 5 && permissions['payroll-history'] && (
                    <PayrollHistory
                      {...props}
                      employee={employee}
                      company={company}
                      fileName={`Payroll_History_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      years={years.sort((a, b) => a.PAYROLL_YEAR - b.PAYROLL_YEAR).map(yr => yr.PAYROLL_YEAR)}
                      accessToken={credentials.user.accessToken}
                      isLoading={loadingTabs.has(5)}
                    />
                  )}
                  {value === 6 && permissions['pay-stubs'] && (
                    <EmployeeChecks
                      accessToken={credentials.user.accessToken}
                      empId={employee.EMPLOYEE}
                      fileName={`Pay_Stubs_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      company={company}
                      data={checks}
                      employee={employee}
                      isLoading={loadingTabs.has(6)}
                      {...props}
                    />
                  )}
                  {value === 7 && permissions['field-history'] && (
                    <FieldHistory
                      accessToken={credentials.user.accessToken}
                      fileName={`Field_History_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      empId={employee.EMPLOYEE}
                      company={company}
                      fields={fields}
                      isLoading={loadingTabs.has(7)}
                      {...props}
                    />
                  )}
                  {value === 8 && permissions['user-fields'] && (
                    <UserFields
                      {...props}
                      data={userFields}
                      fileName={`User_Fields_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      isLoading={loadingTabs.has(8)}
                    />
                  )}
                  {value === 9 && permissions['benefits'] && (
                    <Benefits
                      {...props}
                      data={benefits}
                      fileName={`Benefits_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      isLoading={loadingTabs.has(9)}
                    />
                  )}
                  {value === 10 && permissions['beneficiaries'] && (
                    <Beneficiaries
                      {...props}
                      company={company}
                      empId={employee.EMPLOYEE}
                      credentials={credentials}
                      fileName={`Beneficiaries_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      isLoading={loadingTabs.has(10)}
                    />
                  )}
                  {value === 11 && permissions['dependents'] && (
                    <Dependents
                      {...props}
                      data={dependents}
                      fileName={`Dependents_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      dependentBenefitsData={dependentBenefits}
                      isLoading={loadingTabs.has(11)}
                    />
                  )}
                  {/* {value === 11 && permissions['w2'] && (
                    <Attachments key={`${company}_${employee.EMPLOYEE}`} {...props} type="W2" key1={company} key2={employee.EMPLOYEE}/>
                  )} */}
                  {value === 12 && permissions['position-history'] && (
                    <PositionHistory
                      {...props}
                      data={positionHistory}
                      fileName={`Position_History_${employee.FIRST_NAME}_${employee.LAST_NAME}`}
                      isLoading={loadingTabs.has(12)}
                    />
                  )}
           
                </div>
              </>
              {/* )} */}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
